<template>
  <form-layout :label="label">
    <div class="d-flex flex-column">
      <div class="row row-cols-auto">
        <span v-if="fileName" class="lh-lg align-middle">{{ fileName }}</span>
        <a :href="value" target="_blank" :aria-disabled="!isEnable">
          <base-button class="btn-sm btn-light border-dark px-4" text="確認" :disabled="!isEnable" />
        </a>
        <span v-if="uploadedAt" class="lh-lg align-middle">{{ uploadedAt }}</span>
      </div>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from "@/views/templates/FormLayout";
import BaseButton from '@/views/atoms/BaseButton'

export default {
  name: 'FileBrowseItem',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, null],
      required: true
    },
    fileName: {
      type: String,
      default: ''
    },
    isEnable: {
      type: Boolean,
      default: true
    },
    uploadedAt: {
      type: String,
      default: ''
    },
  },
  components: {
    FormLayout,
    BaseButton,
  },
}
</script>
